export default "__VITE_ASSET__7dNf6Ghy__"